// @material-ui
import { makeStyles } from '@material-ui/core/styles'


export const paymentResultStyle = theme => ({
  root: {
    height: '100%',
  },
})

export const usePaymentResultStyle = makeStyles(paymentResultStyle)
